export enum TransactionTableColumn {
	date = 'date',
	transactionType = 'transactionType',
	securityType = 'securityType',
	securityName = 'securityName',
	totalVolume = 'totalVolume',
	totalValue = 'totalValue',
	vestingTerm = 'vestingTerm',
	investmentReference = 'investmentReference',
}

export type TransactionTableView = 'completed' | 'pending';

export type TransactionTotals = {
	/** Null when the holding has no unit count, e.g. a security issued in currency. */
	volume: number | null;
	volumeDecimalScale: number;
	cost: number;
};

/** `remove` is a transfer's term: it never vests on a schedule, so removing it is the only edit. */
export type TransactionVestingTermAccess = 'edit' | 'remove';

export type TransactionTableVestingTerm = {
	id: string;
	name: string;
};
